import getUniqueStr from './utils/get-unique-str';

const sdkInfo = {
  v: SDK_VERSION,
  startTime: Date.now(),
  sdkid: getUniqueStr()
};
export default sdkInfo;
